import * as THREE from "three";
export class OcclusalArea {
  lineMaterial = new THREE.LineBasicMaterial({
    color: "red",
    side: THREE.DoubleSide,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1,
    blending: THREE.CustomBlending,
    renderOrder: 3,
  });

  constructor() {}

  createContactLines(mesh1, mesh2) {
    let geometry;
    let matrix2to1 = new THREE.Matrix4()
      .copy(mesh1.matrixWorld)
      .invert()
      .multiply(mesh2.matrixWorld);
    const edge = new THREE.Line3();
    const results = [];
    mesh1.geometry.boundsTree.bvhcast(mesh2.geometry.boundsTree, matrix2to1, {
      intersectsTriangles(triangle1, triangle2) {
        if (triangle1.intersectsTriangle(triangle2, edge)) {
          const { start, end } = edge;
          start.applyMatrix4(mesh1.matrixWorld);
          end.applyMatrix4(mesh1.matrixWorld);
          results.push(start.x, start.y, start.z, end.x, end.y, end.z);
        }
      },
    });
    if (results.length) {
      geometry = new THREE.BufferGeometry();
      geometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(results, 3, false),
      );
      geometry.setDrawRange(0, results.length / 3);
      const contactLines = new THREE.LineSegments(geometry, this.lineMaterial);

      return contactLines;
    }
    return null;
  }
}

export class OcclusalSceneController {
  currentVisibleChildIndex = 0;
  occlusalGroups;
  // occlusalAreaManager;
  constructor(groups, maxStepsCount) {
    this.occlusalGroups = groups;
    this.prepareOcclusalGroups(groups, maxStepsCount);
    // this.occlusalAreaManager = new OcclusalArea();
  }

  setCurrentVisibleChild(step, groupIndex = 0) {
    this.#setChildVisibility(this.currentVisibleChildIndex, groupIndex, false);
    this.currentVisibleChildIndex = step;
    this.#setChildVisibility(this.currentVisibleChildIndex, groupIndex, true);
  }
  #setChildVisibility(step, groupIndex, state) {
    this.occlusalGroups[groupIndex].children[step].visible = state;
  }

  turnOffOcclusal() {
    for (
      let groupIndex = 0;
      groupIndex < this.occlusalGroups.length;
      groupIndex++
    ) {
      this.#setChildVisibility(
        this.currentVisibleChildIndex,
        groupIndex,
        false,
      );
    }
  }
  prepareOcclusalGroups(groups, maxStep) {
    for (let step = 0; step <= maxStep; step++) {
      groups.forEach(group => {
        const child = new THREE.Group();
        child.visible = false;
        child.name = `Occ_st${step}`;
        group.add(child);
      });
    }
  }

  offsetGroup(offset, groupIndex) {
    this.occlusalGroups[groupIndex].position.copy(offset);
  }
  isOccReady(step, groupIndex) {
    return this.occlusalGroups[groupIndex].children[step].isOcclusalReady;
  }
  attachOcclusalToStep(object, step, groupIndex) {
    this.occlusalGroups[groupIndex].children[step].attach(object);
    this.occlusalGroups[groupIndex].children[step].isOcclusalReady = true;
  }

  removeOcclusalOfStep(step, groupIndex) {
    const parent = this.occlusalGroups[groupIndex].children[step];

    while (parent.children.length > 0) {
      const child = parent.children[0];
      parent.remove(child);

      // Dispose geometry and material to free memory
      if (child.geometry) child.geometry.dispose();
      if (child.material) {
        child.material.dispose();
      }
    }
  }

  // prepareStepOcclusal(index)
  // {
  //   if (!this.occlusalGroup[index].isOcclusalReady)
  //   {
  //     this.occlusalAreaManager.createContactLines()
  //   }
  // }
}
